export enum LikliHood {
  All = '',
  ExactMatch = 'Exact',
  VeryHigh = 'Very High',
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  VeryLow = 'Very Low',
}

export enum AppLink {
  Dashboard = 'Dashboard',
  BatchScreening = 'BatchScreening',
  RealTimeScreening = 'RealTimeScreening',
}

export enum EntityType {
  Business = 'Business',
  Individual = 'Individual',
}

export enum JobStatus {
  InProgress = 'InProgress',
  Complete = 'Complete',
  Error = 'Error',
  Pending = 'Pending',
}

export enum companySearchBy {
  companyName = 'companyName',
  registrationNo = 'registrationNo',
}

export enum DocumentOrderUIStatus {
  Request = 'REQUEST',
  Failed = 'ERROR',
  Success = 'COMPLETE',
  Pending = 'PENDING',
}

export enum CompanySearchDataProviders {
  DNB = 'dunAndBreadStreet',
  CreditSafe = 'creditsafe',
  KYCKR = 'kyckr',
  KYCKR_LITE = 'kyckrLite',
}
